const mapEnvironmentVariables = () => {
  return {
    AUTH_API_URL: environment.AUTH_API_URL,
  };
};

export default mapEnvironmentVariables;
